import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useParams } from "react-router-dom";
import DropzoneWrapper from "./Dropzone.style";
import { FormattedMessage } from "react-intl";
import AssetUploadModal from "./AssetUploadModal";
import { ReactComponent as CloudImg } from "../../assets/img-cloud.svg";
import { usePermission } from "../../hooks/accessControl";
import Surface from "../layouts/Surface";

const Dropzone = (props) => {
  const { addAsset, branch_id, resource } = props;
  const [toUploadFile, setToUploadFile] = useState(null);

  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  let { id, branchId } = useParams();

  const onDrop = useCallback((acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        fileName: file.name,
      })
    );
    setUploadModalVisible(true);
    setToUploadFile(newFiles[0]);
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: process.env.REACT_APP_CONFIG === "matav" ? 10485760 : 10485760,
    accept:
      "image/jpeg, image/png, application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });
  const closeModal = () => {
    setUploadModalVisible(false);
  };
  const hasEditorPermission = usePermission(branchId, "assets", "editor");

  return (
    <DropzoneWrapper>
      {hasEditorPermission && (
        <Surface>
          <div {...getRootProps({ className: "outer" })}>
            <CloudImg />
            <input {...getInputProps()} />
            <p className="title">
              {<FormattedMessage id="app.actions.dragAndDrop1" />}
            </p>
            <p className="subtitle">
              {<FormattedMessage id="app.actions.dragAndDrop2" />}
            </p>
            <p className="limit">
              {
                <FormattedMessage
                  id={
                    process.env.REACT_APP_CONFIG === "matav"
                      ? "app.actions.dragAndDropMatav3"
                      : "app.actions.dragAndDrop3"
                  }
                />
              }
            </p>
          </div>
        </Surface>
      )}
      <AssetUploadModal
        visible={uploadModalVisible}
        closeModal={closeModal}
        mode={"new"}
        file={toUploadFile}
        addAsset={addAsset}
        branch_id={branch_id}
        id={id}
        resource={resource}
      />
    </DropzoneWrapper>
  );
};

export default Dropzone;
